import type { TenantConfig } from '@/types/TenantConfig'

export const guggenheim: TenantConfig = {
  logo: 'assets/guggenheim/static/logo.svg',
  themeOptions: {
    dialog: {
      headerBackground: '#ececec',
      headerIconColor: '#2b292b',
    },
    mobileFooter: {
      textColor: '#2b292b',
      priceTextColor: '#2b292b',
      cartButtonIconColor: '#2b292b',
      cartButtonBorder: '2px solid #2b292b',
    },
  },
  teaserImageSize: {
    width: 350,
    height: 200,
  },
  // Typography.com fonts don't work in Stripe's <iframe>.
  // stripe: {
  //   font: 'https://cloud.typography.com/710324/624620/css/fonts.css',
  // },
  componentOptions: {
    citypassCoupons: {
      childKeywords: 'child, student',
    },
    cartWidget: {
      dateTimeFormat: 'ddd D MMM @ h:mm A',
    },
    checkoutRoute: {
      stripeWallets: true,
    },
  },
  svgIconOverrides: {
    CalendarIcon: `
      <svg width="26" height="24" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fill="none"
          d="M18.1311 3V4H19.1311H20.1768C20.8175 4 21.2683 4.49396 21.2683 5V19C21.2683 19.506 20.8175 20 20.1768 20H5.53659C4.88883 20 4.44513 19.5092 4.44513 19V5C4.44513 4.49077 4.88883 4 5.53659 4H6.58232H7.58232V3V2H7.67379V3V4H8.67379H17.0396H18.0396V3V2H18.1311V3Z"
          stroke="black"
          stroke-width="2"
        />
        <rect x="7.62805" y="7" width="2.09146" height="2" fill="inherit"/>
        <rect x="7.62805" y="11" width="2.09146" height="2" fill="inherit"/>
        <rect x="11.811" y="7" width="2.09146" height="2" fill="inherit"/>
        <rect x="11.811" y="11" width="2.09146" height="2" fill="inherit"/>
        <rect x="15.9939" y="7" width="2.09146" height="2" fill="inherit"/>
        <rect x="15.9939" y="11" width="2.09146" height="2" fill="inherit"/>
        <rect x="7.62805" y="15" width="2.09146" height="2" fill="inherit"/>
        <rect x="11.811" y="15" width="2.09146" height="2" fill="inherit"/>
        <rect x="15.9939" y="15" width="2.09146" height="2" fill="inherit"/>
      </svg>
    `,
  },
  i18nOverrides: {
    en: {
      membership: {
        title: 'Become a Member',
        renewTitle: 'Renew your Membership',
      },
      payButton: {
        desktop: {
          proceedButtonLabel: 'Continue to Payment',
        },
      },
      checkoutRoute: {
        title: 'Pay For Your Order',
      },
      reserveDateFirst: {
        selectDateLabel: 'Choose a Date',
      },
      selectAvailableSession: {
        title: 'Choose a Time',
      },
      selectTickets: {
        title: 'Choose Your Events',
      },
      citypassCoupons: {
        enableQuestion: 'Will you be using CityPASS, C-All, or C3 to visit the museum?',
        instructions: 'Please enter your CityPASS or C3 barcode numbers',
      },
      applyPromoCodes: {
        applyAnotherPromoCodeLabel: 'Add Another Discount Code',
        applyPromoCodeLabel: 'Add Discount Code',
      },
      termsModal: {
        title: 'Terms & Conditions',
      },
      dateFormat: {
        medium: 'MMMM DD YYYY',
        long: 'dddd, MMMM D, YYYY',
      },
      eventDetail: {
        buttonLabel: {
          donation: 'Add Donation to Order',
          giftcards: 'Add Gift to Order',
        },
      },
      completedOrdersRoute: {
        title: '<span>Done!</span> Thank you for your support!',
      },
    },
  },
  customContent: [
    {
      key: 'member-benefits',
      regions: ['home-member-benefits'],
    },
    {
      key: 'guest-shopping',
      regions: ['home-guest-experience'],
    },
    {
      key: 'before-identity-form',
      regions: ['before-identity-form'],
      template: `<div>All fields are required.</div>`,
    },
    {
      key: 'below-resend-confirmation',
      regions: ['below-resend-confirmation'],
      template: `
        <div>
          Continue shopping or visit <a href="http://guggenheim.org">Guggenheim.org</a> to prepare for your visit.
        </div>
      `,
    },
    {
      key: 'before-resend-tickets',
      regions: ['before-resend-tickets'],
      template: `
        <div>
          The Guggenheim has taken measures to reduce the risks of coronavirus (COVID-19) exposure to you, other visitors, and our staff.
          Please read <a href="http://www.guggenheim.org/plan-your-visit/coronavirus-information">COVID-19 Safety Measures: What to Expect When Visiting</a> and find answers
          to <a href="http://www.guggenheim.org/plan-your-visit/visiting-faq">Frequently Asked Questions</a>.
        </div>
      `,
    },
  ],
}
